/* EdgePro cart MOQ guard: quantities between 1 and the product's MOQ are
   snapped back up to the MOQ. Zero stays allowed so removing a line still
   works. MOQ rides on data-ep-moq, rendered from edgepro.moq in cart line
   markup. Two layers: a capture-phase change listener guards the UI paths
   (typed values and stepper buttons), and a load-time sweep corrects carts
   that arrive below MOQ without a change event (/cart/add?quantity= URLs,
   direct /cart/change.js calls). Checkout-level enforcement (Cart
   Validation Function on the app) is tracked separately for launch. */
(function () {
  if (window.__epCartMoq) return;
  window.__epCartMoq = true;

  document.addEventListener(
    'change',
    function (event) {
      var input = event.target;
      if (!input || !input.classList || !input.classList.contains('quantity__input')) return;
      var moq = parseInt(input.getAttribute('data-ep-moq'), 10);
      if (!moq || moq <= 1) return;
      var value = parseInt(input.value, 10);
      if (!isFinite(value)) return;
      if (value > 0 && value < moq) {
        input.value = moq;
      }
    },
    true
  );

  function sweep() {
    var inputs = document.querySelectorAll('.quantity__input[data-ep-moq]');
    var updates = {};
    var found = false;
    Array.prototype.forEach.call(inputs, function (input) {
      var moq = parseInt(input.getAttribute('data-ep-moq'), 10);
      var value = parseInt(input.value, 10);
      var variantId = input.getAttribute('data-quantity-variant-id');
      if (!moq || moq <= 1 || !variantId || !isFinite(value)) return;
      if (value > 0 && value < moq) {
        updates[variantId] = moq;
        found = true;
      }
    });
    if (!found) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        var applied = cart.items.some(function (item) {
          return updates[String(item.variant_id)] && item.quantity >= updates[String(item.variant_id)];
        });
        /* Only reload once the server confirms the correction, so a
           rejected update can never loop the page. */
        if (applied) window.location.reload();
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sweep);
  } else {
    sweep();
  }
})();
